import { useState, lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Routes, Route } from "react-router-dom";
import CalcStoreProvider from "./hooks/calc-store/CalcStoreProvider";
import { GlobalStyle } from "./GlobalStyle";

import Spinner from "./components/Spinner";

/** PAGES */
const Home = lazy(() => import("./pages/Home"));
const StepOne = lazy(() => import("./pages/steps/StepOne"));
const StepTwo = lazy(() => import("./pages/steps/StepTwo"));
const StepThree = lazy(() => import("./pages/steps/StepThree"));
const StepFour = lazy(() => import("./pages/steps/StepFour"));
const StepFive = lazy(() => import("./pages/steps/StepFive"));
const Summary = lazy(() => import("./pages/Summary"));

function App() {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <CalcStoreProvider>
        <div id="content">
          <div className="branches plaintext">
            <div id="app">
              <Routes>
                <Route
                  path="/"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <Home />
                    </Suspense>
                  }
                />
                <Route
                  path="/:year/step-one"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <StepOne />
                    </Suspense>
                  }
                />
                <Route
                  path="/:year/step-two"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <StepTwo />
                    </Suspense>
                  }
                />
                <Route
                  path="/:year/step-three"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <StepThree />
                    </Suspense>
                  }
                />
                <Route
                  path="/:year/step-four"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <StepFour />
                    </Suspense>
                  }
                />
                <Route
                  path="/:year/step-five"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <StepFive />
                    </Suspense>
                  }
                />
                <Route
                  path="/:year/summary"
                  element={
                    <Suspense fallback={<Spinner />}>
                      <Summary />
                    </Suspense>
                  }
                />
              </Routes>
            </div>
          </div>
        </div>
        <GlobalStyle />
      </CalcStoreProvider>
    </QueryClientProvider>
  );
}

export default App;
